var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.537,
    height: 53.59,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "value_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1796",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 0h57.537v53.59H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2371",
    clipPath: "url(#value_svg__a)",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2643",
    d: "M0 28.311a1.47 1.47 0 011.567-.809c.594.037 1.194-.006 1.789.015a1.09 1.09 0 011.153 1.05 1.055 1.055 0 01-1.037 1.156 23.239 23.239 0 01-2.4.007A1.218 1.218 0 010 28.872z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2644",
    d: "M57.539 28.873a1.369 1.369 0 01-1.46.885c-.6-.016-1.194.011-1.79-.008-.787-.025-1.261-.461-1.261-1.126s.473-1.095 1.266-1.11c.559-.011 1.121.026 1.678-.01a1.467 1.467 0 011.567.808z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2645",
    d: "M28.847 16.192c4.457 0 8.915.015 13.372-.01a3.052 3.052 0 012.8 1.516c1.935 3.023 3.9 6.025 5.853 9.036a2.673 2.673 0 01-.272 3.714q-9.783 10.974-19.579 21.944c-1.427 1.6-3.034 1.6-4.456.007q-9.8-10.967-19.582-21.944a2.675 2.675 0 01-.281-3.713c1.957-3.009 3.932-6.006 5.867-9.028a3.089 3.089 0 012.85-1.532c4.476.028 8.952.011 13.428.011m8.051 13.582l-5.884 19.071.118.05 17.059-19.121zM26.467 48.916l.1-.059-5.881-19.065H9.404l17.063 19.124m2.254-.711l.137.005 5.685-18.425H23.038l5.684 18.42M14.189 19.358l-5.273 8.1h10.523l-5.251-8.1m34.494 8.124l-5.265-8.12-5.258 8.12zm-7.377-8.99H30.846l5.232 8.069 5.227-8.069m-19.786 8.049l5.22-8.063H16.292l5.226 8.063m12.485.951l-5.214-8.041-5.21 8.041z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2646",
    d: "M29.911 4.7c0 1.139.006 2.279 0 3.418-.006.822-.446 1.339-1.114 1.336s-1.123-.519-1.127-1.34c-.011-2.3-.006-4.595 0-6.892 0-.491.127-.988.628-1.147a1.4 1.4 0 011.085.071 1.493 1.493 0 01.508 1.025c.062 1.174.023 2.352.023 3.529"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2647",
    d: "M49.599 9.015a5.574 5.574 0 01-.6 1.009 194.865 194.865 0 01-3.49 3.494 1.13 1.13 0 11-1.58-1.588c1.155-1.174 2.325-2.332 3.494-3.491a1.054 1.054 0 011.313-.329 4.612 4.612 0 01.867.9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2648",
    d: "M14.088 12.633a1.129 1.129 0 01-1.577 1.18 1.585 1.585 0 01-.407-.294q-1.773-1.758-3.535-3.527a1.73 1.73 0 01-.268-.357 1.092 1.092 0 01.184-1.334 1.1 1.1 0 011.345-.144 1.719 1.719 0 01.309.24c1.18 1.174 2.367 2.341 3.528 3.534a2.963 2.963 0 01.422.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue);
export default __webpack_public_path__ + "static/media/value.8a69b70c51b3d59b3bceb9b9a3caea26.svg";
export { ForwardRef as ReactComponent };